import { CardCollectionTemplate, CardSingleTemplate } from '../types';
import { TemplateFilter } from './types';

export function filterBySlug(slug: string): TemplateFilter {
  return t => (t as CardSingleTemplate | CardCollectionTemplate).slug === slug;
}
